import React from 'react';
import s from './style.module.css';
import Heading1 from '@Components/heading_1/view';

type CourseTitleProps = {
    courseName: string;
    tags: string[];
};
const CourseTitle = (props: CourseTitleProps) => {
    return (
        <>
            <Heading1 title={props.courseName} />
            <div className={s.course_tags}>
                {props.tags.map((tag, i) => (
                    <span key={`tag-${i}`} className={`${s.course_tag} ${tag === '新規募集あり' && s.orange}`}>
                        #{tag}
                    </span>
                ))}
            </div>
        </>
    );
};

export default CourseTitle;
